import api from "../config/api";
import type { ApiResponse, Course, PaginatedResponse } from "../types";

export interface CreateCourseRequest {
  name: string;
  category: string;
  description?: string;
  duration: number;
  pricing: {
    sessions: number;
    price: {
      LAK: number;
      THB: number;
      USD: number;
    };
    validityDays: number;
  }[];
  commissionRate: number;
  requirements?: {
    minTherapists: number;
    roomType: string;
  };
  image?: string;
}

export interface GetCoursesParams {
  page?: number;
  limit?: number;
  category?: string;
  isActive?: boolean;
  search?: string;
}

export const courseService = {
  getCourses: async (params: GetCoursesParams = {}): Promise<PaginatedResponse<Course>> => {
    const response = await api.get('/courses', { params });
    return response.data;
  },

  getCourse: async (id: string): Promise<ApiResponse<Course>> => {
    const response = await api.get(`/courses/${id}`);
    return response.data;
  },

  createCourse: async (data: CreateCourseRequest): Promise<ApiResponse<Course>> => {
    const response = await api.post('/courses', data);
    return response.data;
  },

  updateCourse: async (id: string, data: Partial<CreateCourseRequest>): Promise<ApiResponse<Course>> => {
    const response = await api.put(`/courses/${id}`, data);
    return response.data;
  },

  deleteCourse: async (id: string): Promise<ApiResponse<Course>> => {
    const response = await api.delete(`/courses/${id}`);
    return response.data;
  },

  getCoursesByCategory: async (categoryId: string, isActive = true): Promise<ApiResponse<Course[]>> => {
    const response = await api.get(`/courses/category/${categoryId}`, { params: { isActive } });
    return response.data;
  },
};